<template>
  <div v-loading="loading" class="addVotingBox">
    <!-- 表单提交 -->
    <div class="formData">
      <div class="votingName">
        <i class="title">投票名称:</i>
        <InputComp
          :value="name"
          placeholder="投票名称只用于管理，不显示在下发的投票内容中"
          @inputEmit="
            (e) => {
              name = e;
            }
          "
        />
      </div>
      <div class="endTime">
        <i class="title">截止时间:</i>
        <DateTime :init-date-time="initDateTime" @dateTimeEmit="dateTimeEmit" />
      </div>
      <!-- 增加问题 -->
      <div class="addQuestionContent">
        <p class="title">
          上传图片的最佳尺寸：300像素*300像素，其他尺寸会影响页面效果，格式png、jpeg、jpg、gif，大小不超过1M
        </p>
        <!-- 问题提交列表 -->
        <ul class="questionItem">
          <li v-for="(item, index) in topics" class="item" :key="index">
            <!-- 问题未展开状态 -->
            <div v-if="!item.isOpen" class="close">
              <p class="leftTitle">问题{{ getChinese(index + 1) }}</p>
              <p class="title">
                {{ item.topic_name }}
              </p>
              <div class="rightContent">
                <el-button class="openButton" type="text" @click="openItem(index, item)">
                  展开
                </el-button>
                <el-button class="deleteButton" type="text" @click="deleteQuestion(index)">
                  删除
                </el-button>
              </div>
            </div>
            <!-- 问题展开状态 -->
            <div v-else class="open">
              <div class="title">
                问题{{ getChinese(index + 1) }}
                <el-button class="closeButton" type="text" @click="closeItem(index, item)">
                  收起
                </el-button>
              </div>
              <!-- 问题标题 -->
              <div class="editTitle">
                <h6 class="leftTitle">标题:</h6>
                <InputComp
                  :value="item.topic_name"
                  :maxlength="110"
                  @inputEmit="
                    (val) => {
                      item.topic_name = val;
                    }
                  "
                  @blurEmit="
                    (e) => {
                      titleBlur();
                    }
                  "
                />
              </div>
              <!-- 选择方式 -->
              <div class="selectMethods">
                <h6 class="leftTitle">选择方式:</h6>
                <el-radio-group v-model="item.option_type" @change="changeType(item)">
                  <el-radio :label="1">单选框</el-radio>
                  <el-radio :label="2">多选框</el-radio>
                  <el-radio :label="3">简答题</el-radio>
                </el-radio-group>
              </div>
              <!-- 选择项 -->
              <div v-if="item.option_type === 1 || item.option_type === 2" class="itemList">
                <div v-for="(item2, index2) in item.options" class="item" :key="index2">
                  <h6 class="leftTitle">选项{{ getChinese(index2 + 1) }}:</h6>
                  <div class="rightContent">
                    <div class="editContent">
                      <div v-if="item2.option_img" class="upImg">
                        <img :src="item2.option_img" alt="" />
                        <div class="deleteImg" @click="deleteImg(index, index2, item2)">
                          <i class="delete el-icon-delete" />
                        </div>
                      </div>
                      <InputComp
                        v-if="item2.option_img"
                        type="textarea"
                        :out-style="{ width: '75%' }"
                        :value="item2.option_name"
                        @inputEmit="
                          (val) => {
                            item.options[index2].option_name = val;
                          }
                        "
                        @blurEmit="
                          (e) => {
                            optionBlur(index, index2);
                          }
                        "
                      />
                      <InputComp
                        v-else
                        :value="item2.option_name"
                        @inputEmit="
                          (val) => {
                            item.options[index2].option_name = val;
                          }
                        "
                        @blurEmit="
                          (e) => {
                            optionBlur(index, index2);
                          }
                        "
                      />
                    </div>
                    <div class="editList">
                      <el-upload
                        class="avatar-uploader"
                        :action="uploadUrl"
                        :show-file-list="false"
                        :http-request="(file) => handleRequest(file, index, index2)"
                      >
                        <el-button icon="el-icon-picture" round />
                      </el-upload>
                      <el-button
                        v-if="item.options.length == index2 + 1"
                        icon="el-icon-plus"
                        round
                        @click="addQuestionItem(item, index, index2)"
                      />
                      <el-button
                        v-if="item.options.length > 1"
                        icon="el-icon-minus"
                        round
                        @click="deleteQuestionItem(item, index, index2)"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <el-button class="addQuestionButton" type="primary" icon="el-icon-plus" @click="addQuestion">
        添加问题
      </el-button>
      <div class="endTime">
        <i class="title">标签:</i>
        <!--动态标签选择-->
        <el-form ref="form" :model="form" label-width="96px" class="edit-form">
          <LabelSelect
            :products="form.product"
            :departments="form.department"
            :tags="form.tags"
            :label-amount="10"
            ref="labelSelect"
          ></LabelSelect>
        </el-form>
      </div>
    </div>
    <!-- 保存与发布 -->
    <div class="oprationList">
      <el-button @click="clickSubmitBtn(1)" :disabled="isDisable">保存</el-button>
      <el-button type="primary" @click="clickSubmitBtn(2)" :disabled="isDisable">发布</el-button>
    </div>
  </div>
</template>

<script>
import { CosMixin } from '@/mixins/cos';
import { topics as questionListTemplate } from './field';
import { getChinese } from '@/utils/util.js';

import InputComp from '@/components/input-show-word-limit';
import DateTime from '@/components/date-time';
import { GetVoteByIDApi, AddVoteApi } from '@/api/releaseManagement';
import { GetProductInfoList, GetLabelInfoList } from '@/api/setUser.js';
import { getHospitalDepartmentListApi } from '@/api/setUp.js';
import LabelSelect from '@/components/labelSelect';

export default {
  name: 'AddVoting',
  components: {
    InputComp,
    DateTime,
    LabelSelect,
  },
  mixins: [CosMixin],
  data() {
    return {
      name: '' /* 投票名称 */,
      endtime: '' /* 截止日期 */,
      hour: '' /* 时 */,
      minute: '' /* 分 */,
      dateTime: '', // 日期时间组件数据
      initDateTime: '', // 初始化日期时间组件数据
      topics: questionListTemplate() /* 问题列表 */,
      loading: false,
      title1: '',
      onAvatarProgressMessage: '', // 上传图片时的message,
      query: '', // 请求参数暂存
      tempClick: '', // 点击保存或者发布暂存0 1
      begin_time: '',
      isDisable: false,
      vote_id: '',
      // 下拉框------------------
      // 回显 [{TagId:1, TagType:'xxx'}]
      form: {
        product: [],
        department: [],
        tags: [],
      },
      // 上传 [{id:1, name:'xxx'}]
      formUp: {
        product: [],
        department: [],
        tags: [],
      },
    };
  },
  computed: {
    // 上传地址
    uploadUrl() {
      return '';
    },
  },
  created() {
    this.vote_id = this.$route.query.date;
    let voteTitle;
    if (this.vote_id) {
      this.getVotesInfo({ vote_id: this.vote_id });
      voteTitle = '编辑投票';
    } else {
      voteTitle = '新增投票';
    }
    // 设置面包屑
    const breadcrumb = [
      { menu_name: '发布管理', menu_path: '', menu_params: {} },
      { menu_name: '投票管理', menu_path: 'voteManagement', menu_params: {} },
      { menu_name: voteTitle, menu_params: { componentName: 'addVoting' } },
    ];
    this.g_breadcrumb(breadcrumb);

    this.getSelectList();
  },
  methods: {
    async getSelectList() {
      // 产品
      GetProductInfoList().then((res) => {
        this.productSelect = res.list;
      });
      // 科室
      getHospitalDepartmentListApi().then((res) => {
        this.departmentSelect = res.data;
      });
      // 自定义标签
      GetLabelInfoList({ label_type: 0, page_index: 1, page_size: 99999 }).then((res) => {
        this.diySelect = res.list;
      });
    },
    // 日期时间组件回调
    dateTimeEmit(e) {
      this.dateTime = e;
    },
    // 查询投票基本信息
    async getVotesInfo(query) {
      this.loading = true;
      try {
        GetVoteByIDApi(query)
          .then((data) => {
            if (data) {
              const data2 = data.vote_info;
              data2.end_time = parseInt(data2.end_time * 1000, 0);
              this.initDateTime = data2.end_time; // 给时间日期组件使用
              this.$message.success('信息读取成功');
              this.name = data2.name;
              this.topics = data2.topics;
              // 回显下拉框---
              this.filterSelectTapShow(data2);
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } catch (error) {
        this.$message.error(error);
      }
      this.loading = false;
    },
    beginTime() {
      const yy = new Date().getFullYear();
      const mm =
        new Date().getMonth() < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1;
      const dd = new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate();
      const hh = new Date().getHours();
      const mf =
        new Date().getMinutes() < 10 ? `0${new Date().getMinutes()}` : new Date().getMinutes();
      const ss =
        new Date().getSeconds() < 10 ? `0${new Date().getSeconds()}` : new Date().getSeconds();
      this.begin_time = `${yy}-${mm}-${dd} ${hh}:${mf}:${ss}`;
    },
    // 过滤下拉框回显格式(前端要的格式)
    filterSelectTapShow(data) {
      const arr1 = data.prod_ids ? data.prod_ids : [];
      const arr2 = data.depart_ids ? data.depart_ids : [];
      const arr3 = data.label_ids ? data.label_ids : [];
      const arr1Temp = [];
      const arr2Temp = [];
      const arr3Temp = [];
      arr1.forEach((_) => {
        arr3Temp.push({ TagId: _.id, TagType: 1 });
      });
      arr2.forEach((_) => {
        arr3Temp.push({ TagId: _.id, TagType: 2 });
      });
      arr3.forEach((_) => {
        arr3Temp.push({ TagId: _.id, TagType: 3 });
      });
      this.form.product = arr1Temp;
      this.form.department = arr2Temp;
      this.form.tags = arr3Temp;
    },
    // 过滤下拉框上传格式(后端要的格式)
    filterSelectTapUpload() {
      console.log(this.$refs.labelSelect.commitTags());

      //   if (this.$refs.labelSelect.hasNoProduct()) {
      //     this.$message.warning('请至少选择一个产品标签');
      //     return false;
      //   }
      const arr = this.$refs.labelSelect.commitTags();
      const arr1 = [];
      const arr2 = [];
      const arr3 = [];
      arr.forEach((_) => {
        switch (_.TagType) {
          // 产品
          case 1:
            arr1.push({ id: _.TagId, name: '' });
            break;
          // 科室
          case 2:
            arr2.push({ id: _.TagId, name: '' });
            break;
          // 动态标签
          case 3:
            arr3.push({ id: _.TagId, name: '' });
            break;
          default:
            break;
        }
      });
      this.formUp.product = arr1;
      this.formUp.department = arr2;
      this.formUp.tags = arr3;
    },
    // 点击保存-1 发布-2
    clickSubmitBtn(e) {
      //   this.filterSelectTapUpload();
      this.isDisable = true; // 点击后禁用该按钮；
      setTimeout(() => {
        this.isDisable = false; // 响应后延迟几秒回复正常；
      }, 2500);
      const { name } = this;
      if (!name) {
        this.$message.warning('请输入投票名称');
        return;
      }
      const { dateTime } = this;
      if (!dateTime) {
        this.$message.warning('请选择截止时间');
        return;
      }
      if (!dateTime.date) {
        this.$message.warning('请选择日期');
        return;
      }
      if (!dateTime.hour) {
        this.$message.warning('请选择时间');
        return;
      }
      if (!dateTime.minute) {
        this.$message.warning('请选择分钟');
        return;
      }
      this.filterSelectTapUpload();
      // const endTime = `${dateTime.date} ${dateTime.hour}:${dateTime.minute}:00`;
      // const endTimes = Math.floor(new Date(endTime).getTime() / 1000);
      const [year, month, day] = dateTime.date.split('-');
      let endTimes = new Date().setFullYear(year, Number.parseInt(month, 10) - 1, day);
      endTimes = new Date(endTimes).setHours(dateTime.hour, dateTime.minute, 0, 0) / 1000;
      this.begin_time = Math.floor(new Date().getTime() / 1000);
      if (endTimes <= this.begin_time) {
        this.$message.warning('截止时间应大于当前时间');
        return;
      }

      if (!this.checkQuestionInfoList()) {
        return;
      }
      // this.beginTime();
      let topics = '';
      try {
        topics = JSON.parse(JSON.stringify(this.topics));
      } catch (err) {
        this.$message.error(err);
      }
      topics.forEach((e1) => {
        const e1s = e1;
        delete e1s.isOpen;
      });

      // 如果是编辑, 保存发布要带voteId
      let query = {};
      if (this.vote_id) {
        query = {
          vote_info: {
            name,
            begin_time: this.begin_time,
            end_time: endTimes,
            vote_id: this.vote_id,
            status: e,
            topics,
            enterprise_id: '',
            // 下拉框
            prod_ids: this.formUp.product,
            depart_ids: this.formUp.department,
            label_ids: this.formUp.tags,
          },
        };
      } else {
        query = {
          vote_info: {
            name,
            begin_time: this.begin_time,
            end_time: endTimes,
            vote_id: '',
            status: e,
            topics,
            enterprise_id: '',
            // 下拉框
            prod_ids: this.formUp.product,
            depart_ids: this.formUp.department,
            label_ids: this.formUp.tags,
          },
        };
      }
      this.query = query;

      e === 2 ? (this.title1 = '确定发布该投票吗？') : (this.title1 = '确定保存该投票吗？');
      this.tempClick = e;
      this.dialogEmit();
    },
    // 弹框确认回调
    async dialogEmit() {
      this.$confirm(this.title1, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
      })
        .then(() => {
          this.submitFun();
        })
        .catch(() => {});
    },
    // 发布-保存
    async submitFun() {
      try {
        this.loading = true;
        AddVoteApi(this.query)
          .then((res) => {
            if (res) {
              const tip = new Map([
                [1, '保存'],
                [2, '发布'],
              ]);
              this.$message.success(`${tip.get(this.tempClick)}成功`);
              this.closeComp('saveOrPublish');
            }
          })
          .catch((err) => {
            this.$message.error(err);
          });
      } catch (error) {
        this.$message.error(error);
      }
      this.loading = false;
    },
    async handleRequest(file, index, index2) {
      if (!/.jpg|.png|.jpeg|.gif$/gi.test(file.file.name)) {
        this.$message('只支持上传png、jpeg、jpg、gif，大小不超过1M的图片');
        return false;
      }
      const isLt2M = file.file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$message.error('上传图片大小超出限制!');
        return false;
      }
      this.onAvatarProgressMessage = this.$loading({
        lock: true,
        text: '图片上传中',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      const cosParams = {
        imgCosKey: `${file.file.uid}${rs}`,
        fileObject: file.file,
      };
      const res = await this.putCosObject(cosParams);
      this.topics[index].options[index2].option_img = res.data;
      this.onAvatarProgressMessage.close();
      this.$message.success('上传成功');
      return;
    },
    /* 删除图片 */
    deleteImg(index1, index2, item) {
      this.$confirm('确定删除该图片吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        const items = item;
        items.option_img = '';
        this.$set(this.topics[index1], index2, items);
      });
    },
    /* 增加问题选项 */
    addQuestionItem(item, index, index2) {
      if (item.options.length === 30) {
        this.$message({
          message: '最多三十个问题选项',
          type: 'warning',
        });
        return false;
      }
      let newItem = '';
      try {
        newItem = JSON.parse(JSON.stringify(item));
      } catch (err) {
        this.$message.error(err);
      }
      const newItemIn = Object.assign({}, newItem.options[0]);
      // for (const i in newItemIn) {
      //   newItemIn[i] = '';
      // }
      Object.keys(newItemIn).forEach((i) => {
        console.log(newItemIn[i]);
        newItemIn[i] = '';
      });
      newItem.options.splice(index2 + 1, 0, newItemIn);
      this.$set(this.topics, index, newItem);
    },

    /* 删除问题选项 */
    deleteQuestionItem(item, index, index2) {
      let newItem = '';
      try {
        newItem = JSON.parse(JSON.stringify(item));
      } catch (err) {
        this.$message.error(err);
      }
      newItem.options.splice(index2, 1);
      this.$set(this.topics, index, newItem);
    },
    /* 添加问题 */
    addQuestion() {
      const { topics } = this;
      // 新增的问题填写完整才能追加下一个问题
      if (!this.checkQuestionInfoList()) {
        return false;
      }

      // if (topics.length === 10) {
      //   this.$message({
      //     message: '最多十个问题',
      //     type: 'warning',
      //   });
      //   return false;
      // }

      // 收缩
      for (let i = 0; i < topics.length; i++) {
        const e = topics[i];
        e.isOpen = false;
      }

      this.$set(topics, topics.length, ...questionListTemplate());
    },
    // 检验新增的问题是否填写完毕
    checkQuestionInfoList() {
      const { topics } = this;
      for (let i = 0, ilen = topics.length; i < ilen; i++) {
        if (!topics[i].topic_name) {
          this.$message.warning('请输入问题标题');
          return false;
        }
        // 简答题跳过
        if (topics[i].option_type === 3) {
          continue;
        }
        for (let j = 0, jlen = topics[i].options.length; j < jlen; j++) {
          if (!topics[i].options[j].option_name) {
            this.$message.warning('请输入问题选项');
            return false;
          }
        }
      }
      return true;
    },
    /* 删除问题 */
    deleteQuestion(index) {
      this.topics.splice(index, 1);
    },
    /* 展开问题(其他收缩) */
    openItem(index) {
      const { topics } = this;
      for (let i = 0; i < topics.length; i++) {
        const e = topics[i];
        e.isOpen = false;
      }
      topics[index].isOpen = true;
      this.topics = topics.reverse().reverse();
    },
    /* 关闭问题 */
    closeItem(index, item) {
      const items = item;
      items.isOpen = false;
      this.$set(this.topics, index, items);
    },
    /* 获取中文序号 */
    getChinese(index) {
      return getChinese(index);
    },
    // 隐藏组件  val = 'back'(返回)  'saveOrPublish'(保存或发布)
    closeComp() {
      this.g_tourl(`/saas/voteManagement.html`);
    },
    /** 重叠判断
     *  传入数组
     *  回调数组格式的两个重复位置的索引 eg:[1,3]
     */
    overlayFun(arr = []) {
      const cordIndex = [];
      for (let i = 0; i < arr.length; i++) {
        for (let j = i + 1; j < arr.length; j++) {
          if (arr[i] === arr[j] && arr[i] !== '' && arr[j] !== '') {
            // 第一个等同于第二个，splice方法删除第二个
            // arr.splice(j, 1);
            cordIndex.push([i + 1, j + 1]);
            // j--;
          }
        }
      }
      return cordIndex;
    },
    // 选项失去焦点对比是否重复
    optionBlur(index1) {
      const { options } = this.topics[index1];
      const arr = [];
      options.forEach((e) => {
        arr.push(e.option_name);
      });

      const cordIndex = this.overlayFun(arr);

      if (cordIndex.length > 0) {
        let tip = '';
        cordIndex.forEach((e) => {
          tip += ` 选项${e[0]}和选项${e[1]} `;
        });
        this.$message.info(`温馨提示: ${tip}文字相同`);
      }
    },
    // 提交标题问题对比是否重复
    titleBlur() {
      const { topics } = this;
      const arr = [];
      topics.forEach((e) => {
        arr.push(e.topic_name);
      });

      const cordIndex = this.overlayFun(arr);

      if (cordIndex.length > 0) {
        let tip = '';
        cordIndex.forEach((e) => {
          tip += `问题${e[0]}和问题${e[1]} `;
        });
        this.$message.info(`温馨提示: ${tip}文字相同`);
      }
    },
    changeType(item) {
      if ([1, 2].includes(item.option_type) && item.options.length === 0) {
        item.options.push({
          option_name: '',
          option_img: '',
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>
